var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlobExtend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3705 36.2568C64.1041 41.1466 59.2469 45.6127 56.9966 50.6569C54.7463 55.7011 55.0446 61.3016 52.7997 63.2209C50.5365 65.1002 45.7408 63.2691 41.8659 61.0181C38.0201 58.7781 35.1061 56.089 31.9218 52.1676C28.7376 48.2462 25.2758 43.0233 26.1323 38.6874C26.9996 34.3223 32.1487 30.7639 37.8516 27.9454C43.5654 25.0977 49.8439 22.9607 55.1017 24.5326C60.3596 26.1045 64.655 31.4071 64.3705 36.2568Z",
    fill: "#FA7B6A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9564 21.1621L48.5324 17.6446L49.788 16.3548L54.4675 21.1621L49.788 25.9694L48.5324 24.6796L51.9564 21.1621Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10003 38.021L9.10003 20.0998L52.3779 20.0998L52.3779 21.8998L10.9 21.8998L10.9 38.021L9.10003 38.021Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2989 42.6052C9.54413 42.6052 8.9001 43.2354 8.9001 44.0529C8.9001 44.8704 9.54413 45.5006 10.2989 45.5006C11.0536 45.5006 11.6976 44.8704 11.6976 44.0529C11.6976 43.2354 11.0536 42.6052 10.2989 42.6052ZM7.1001 44.0529C7.1001 42.2772 8.51445 40.8052 10.2989 40.8052C12.0833 40.8052 13.4976 42.2772 13.4976 44.0529C13.4976 45.8286 12.0833 47.3006 10.2989 47.3006C8.51445 47.3006 7.1001 45.8286 7.1001 44.0529Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4589 29.7188C19.866 29.7188 17.0933 32.6716 17.0933 38.6256C17.0933 44.0714 20.1504 46.9274 26.004 46.9274C30.6015 46.9274 33.5638 44.8217 33.5638 41.53C33.5638 37.1976 30.0564 36.0842 26.2647 36.0842C24.5109 36.0842 22.1174 36.3263 19.2735 38.432C19.3683 34.0996 21.122 31.655 25.5774 31.655C28.2316 31.655 30.9096 32.3811 31.6206 35.1887L33.3032 34.511C32.5685 30.4933 28.8241 29.7188 25.4589 29.7188ZM19.6053 40.6829C21.3827 38.6982 24.0844 37.9721 26.1462 37.9721C28.9426 37.9721 31.5732 38.8918 31.5732 41.53C31.5732 43.8293 28.8952 44.8701 26.1462 44.8701C22.852 44.8701 20.1978 43.7083 19.6053 40.6829Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8389 30.2512H38.9087V39.3275C39.3353 39.5937 39.9752 40.0294 40.4254 40.2472C41.7289 38.7708 44.7149 38.1657 46.8715 38.1657C49.7864 38.1657 52.7962 38.916 52.7962 41.2638C52.7962 44.1924 49.2888 44.9427 46.7293 44.9427C44.2172 44.9427 41.1601 44.5312 39.8567 42.4013C39.4064 42.7402 38.7428 43.1516 38.2689 43.4905C39.5723 46.4191 43.7907 47 46.8715 47C50.687 47 55.0001 45.5962 55.0001 40.9975C55.0001 37.246 50.9477 36.1811 47.2033 36.1811C45.3074 36.1811 42.5346 36.5441 40.8283 37.8027V32.2117H53.8863L53.8389 30.2512Z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlobExtend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlobExtend.a1eab6ed9fbbdc6c0264a571e4aa74c9.svg";